import { Component } from '@angular/core';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from '../../app.main.component';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { getDisplayName, getInitials } from 'src/app/core/functions';
import { AuthService } from 'src/app/auth/auth.service';
import { ChevronDown, LogOut, Menu, Moon, Settings, Sun } from 'lucide-angular';
import { ThemeService } from 'src/app/core/services/theme.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    standalone: false
})
export class AppTopbarComponent {

    readonly Menu = Menu;
    readonly ChevronDown = ChevronDown;
    readonly Settings = Settings;
    readonly LogOut = LogOut;
    readonly Sun = Sun;
    readonly Moon = Moon;

    user: any;
    avatar: string;
    displayName: string;

    constructor(public app: AppComponent, public appMain: AppMainComponent, public afAuth: AngularFireAuth,
        private authService: AuthService, public themeService: ThemeService) {
        this.afAuth.authState.subscribe((user) => {
            this.user = user;
            this.avatar = getInitials(this.user);
            this.displayName = getDisplayName(this.user);
        });
    }

    toggleTheme() {
        this.themeService.toggle();
    }

    logout() {
        this.authService.SignOut();
    }
}
